import { Cell, Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestMetricType } from '../../client/generated/graphql';
import { getAchievementMetricTypeDescription, getConditionIcon } from '../../helpers/achievement';
import { CommonIcon } from './CommonIcon';
import { LiquidGlassRowCard } from './LiquidGlassRowCard';

function getConditionQuestSubtitle(questIds: string[], linkedNewQuestNames: string[] | undefined, t: ReturnType<typeof useTranslation>['t']): string {
  const linked = (linkedNewQuestNames?.length ?? 0) > 0;
  const namesLine = linkedNewQuestNames?.join(', ') ?? '';
  const newQuestLabel = t('conditionPicker.newQuest', { count: linkedNewQuestNames?.length ?? 0 });
  if (linked && questIds.length > 0) {
    return t('conditionPicker.linkedWithOthers', { label: newQuestLabel, names: namesLine, count: questIds.length });
  }
  if (linked) return t('conditionPicker.linked', { label: newQuestLabel, names: namesLine });
  return t('conditionPicker.selected', { count: questIds.length });
}

interface ConditionPickerProps {
  metricType: QuestMetricType;
  target: number | null;
  questIds: string[];
  linkedNewQuestNames?: string[];
  onClick: () => void;
}

export const ConditionPicker: FC<ConditionPickerProps> = ({
  metricType,
  target,
  questIds,
  linkedNewQuestNames,
  onClick,
}) => {
  const { t } = useTranslation();
  const conditionIcon = getConditionIcon(metricType);
  const questSubtitle = getConditionQuestSubtitle(questIds, linkedNewQuestNames, t);
  return (
    <LiquidGlassRowCard>
      <Cell
        onClick={onClick}
        before={
            <CommonIcon
              icon={conditionIcon}
              type="filled"
              size={30}
              color={'var(--tg-theme-button-color)'}
            />
        }
        subtitle={questSubtitle}
      >
        <Text weight="2" style={{ fontSize: '16px' }}>
          {getAchievementMetricTypeDescription(metricType, target)}
        </Text>
      </Cell>
    </LiquidGlassRowCard>
  );
};
